var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "carousel" },
      [
        _vm.showArrows
          ? _c("div", { staticClass: "nav-swiper" }, [
              _c("div", {
                staticClass: "left-arrow swiper-button-prev",
                on: { click: _vm.prevSwiper },
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "right-arrow swiper-button-next",
                on: { click: _vm.nextSwiper },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showArrows
          ? _c(
              "div",
              {
                staticClass:
                  "swiper-button-prev swiper-button-prev--simple icon d-none d-lg-flex swiper-button-next--rounded",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.prevSwiper.apply(null, arguments)
                  },
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/sprite/svg/slider_simple_larr.svg"),
                    alt: "",
                  },
                }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showArrows
          ? _c(
              "div",
              {
                staticClass:
                  "swiper-button-next swiper-button-next--simple icon d-none d-lg-flex swiper-button-next--rounded",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.nextSwiper.apply(null, arguments)
                  },
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/sprite/svg/slider_simple_rarr.svg"),
                    alt: "",
                  },
                }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "swiper-container",
          {
            ref: "swiper",
            attrs: {
              "slides-per-view": _vm.slidesPerView,
              loop: true,
              pagination: _vm.normalizedPagination,
              "pagination-clickable": _vm.normalizedPagination,
              "dynamic-bullets": "true",
              fade: "true",
              "space-between": "20",
            },
          },
          [_vm._t("default")],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }